import { useQuery } from "@tanstack/react-query";

import { ONE_SECOND_MS } from "#/config/time";

import { fetchCloudflareStatus } from "../vendor.service";

export const useCloudflareStatus = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["fetchCloudflareStatus"],
    queryFn: fetchCloudflareStatus,
    select: ({ data: responseData }) => ({
      shouldShowWarning: ["major", "critical"].includes(
        responseData?.status.indicator ?? "",
      ),
      url: responseData?.page.url ?? "",
    }),
    refetchInterval: ONE_SECOND_MS * 30,
  });

  return {
    data: data ?? { shouldShowWarning: false, url: "" },
    isLoading,
    refetch,
  };
};
